export const OTP_REPORT_BY_APP_REQUEST = "OTP_REPORT_BY_APP_REQUEST";
export const OTP_REPORT_BY_APP_SUCCESS = "OTP_REPORT_BY_APP_SUCCESS";
export const OTP_REPORT_BY_APP_ERROR = "OTP_REPORT_BY_APP_ERROR";
